module.exports = __webpack_public_path__ + "img/76298.acf1d64c.svg";